import { render } from "./SelectClientPage.vue?vue&type=template&id=eed6017e"
import script from "./SelectClientPage.vue?vue&type=script&lang=js"
export * from "./SelectClientPage.vue?vue&type=script&lang=js"

import "./SelectClientPage.vue?vue&type=style&index=0&id=eed6017e&lang=css"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__